import React from 'react'
import { theme as Theme, ConfigProvider } from 'antd'
import type { GlobalToken } from 'antd'
import { useStyleRegister } from '@ant-design/cssinjs'
import type { CSSInterpolation } from '@ant-design/cssinjs'

export type { GlobalToken }
export type GenerateStyle<T> = (token: T) => CSSInterpolation
export type FullToken = GlobalToken & {
  componentCls: string
  prefixCls: string
  iconCls: string
  antCls: string
  lineWidth: number
  opacityLoading: number
  colorTextLightSolid: string
  colorBgContainerDisabled: string
}

export function genComponentStyleHook(
  componentNames: [string, string],
  styleFn: (token: FullToken) => CSSInterpolation,
) {
  const concatComponent = componentNames.join('-')

  return (prefixCls: string): void => {
    const { theme, token, hashId } = Theme.useToken()
    const { getPrefixCls, iconPrefixCls } = React.useContext(ConfigProvider.ConfigContext)
    const rootPrefixCls = getPrefixCls()

    const sharedConfig = {
      theme: theme as any,
      token,
      hashId,
    }

    useStyleRegister(
      { ...sharedConfig, path: [concatComponent, prefixCls, iconPrefixCls] },
      () => {
        const componentCls = `.${prefixCls}`
        const mergedToken = {
          ...token,
          componentCls,
          prefixCls,
          iconCls: `.${iconPrefixCls}`,
          antCls: `.${rootPrefixCls}`,
        } as FullToken

        return styleFn(mergedToken)
      },
    )
  }
}
